import { render } from "./side-menu-element.vue?vue&type=template&id=48dda4c0"
import script from "./side-menu-element.vue?vue&type=script&lang=js"
export * from "./side-menu-element.vue?vue&type=script&lang=js"

import "./side-menu-element.vue?vue&type=style&index=0&id=48dda4c0&lang=scss"

import exportComponent from "/usr/src/oho-accounting-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__